import React from 'react'
import './UserHome.css'
import { IoHomeOutline, IoBasketOutline } from 'react-icons/io5'
import { AiOutlineLogout } from 'react-icons/ai'
import { BsBookmarkStar } from 'react-icons/bs'
import { FiSearch } from 'react-icons/fi'
import { Row, Col } from 'react-bootstrap'
import UserHomeStatisticsItem from '../UserHomeStatisticsItem/UserHomeStatisticsItem'
import UserPanelTitle from '../UserPanelTitle/UserPanelTitle'
import UserHomeLastCourse from '../UserHomeLastCourse/UserHomeLastCourse'
import { shuffle } from "lodash";
import { BsPersonVideo3, BsBookmarks } from 'react-icons/bs'
import { SiShopify } from 'react-icons/si'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
export default function UserHome({ user }) {
  const colors = [
    "linear-gradient(20deg,#916aff,#af93ff)",
    "linear-gradient(20deg,#79b8ca,#9acad7)",
    "linear-gradient(20deg,#ff905f,#ffb08d)",
  ];
  const shuffledColors = shuffle(colors);
  const navigate = useNavigate();
  const logOut = () => {
    Swal.fire({
      icon: 'error',
      text: 'از حساب کاربری خارج شوید؟',
      confirmButtonText: "بله",
      showCancelButton: true,
      cancelButtonText:
        'خیر',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        navigate('/')
      }
    })
  }
  return (
    <>
      <div className='user-panel-navbar'>
        <Row>
          <Col>
            <div className='user-panel-navbar-right'>
              <div className='user-panel-navbar-icon'>
                <Link to='/'>
                  <IoHomeOutline />
                </Link>
              </div>
              <div className='user-panel-navbar-icon'>
                <Link to='/userpanel/order'>
                  <IoBasketOutline />
                </Link>
              </div>
              <div className='user-panel-navbar-icon'>
                <Link to='/userpanel/saveItems'>
                  <BsBookmarkStar />
                </Link>
              </div>
              <div className='user-panel-navbar-icon'>
                <Link>
                  <AiOutlineLogout onClick={logOut} />
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className='user-home-statistics'>
        <UserPanelTitle title='برخی آمار ها' />
        <Row>
          <Col md={6} lg={4}>
            <Link to='/userpanel/order'>
              <UserHomeStatisticsItem count={user.factorItems.length == 0 ? '0' : user.factorItems.filter(p => p.contentType == 1).length} title='محصولات خریداری شده' icon={<SiShopify />} background={shuffledColors[0]} />
            </Link>
          </Col>
          <Col md={6} lg={4}>
            <Link to='/userpanel/order'>
              <UserHomeStatisticsItem count={user.factorItems.length == 0 ? '0' : user.factorItems.filter(p => p.contentType == 0).length} title='آموزش های خریداری شده' icon={<BsPersonVideo3 />} background={shuffledColors[1]} />
            </Link>
          </Col>
          <Col md={6} lg={4}>
            <Link to='/userpanel/saveItems'>
              <UserHomeStatisticsItem count={user.registeredCourseSave?.length == 0 ? '0' : user.registeredCourseSave.length} title='آموزش های سیو شده' icon={<BsBookmarks />} background={shuffledColors[2]} />
            </Link>
          </Col>
        </Row>
      </div>
      <UserHomeLastCourse />
    </>


  )
}
